module.exports = __webpack_public_path__ + "img/hero.301a2d5e.jpg";